import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatEdid'
})
export class FormatEdidPipe implements PipeTransform {
  private ANZAHL_STELLEN = 2;

  constructor() {
  }

  transform(edid: number): string {
    if (edid === 0) {
      return '00';
    }
    if (!edid) {
      return null;
    }
    return (edid + Math.pow(10, this.ANZAHL_STELLEN) + "").slice(1);
  }

}
